import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";
import { Helmet } from "react-helmet";
import useLogic from "./useLogic";
import OtpForm from "./OtpForm";
import useVerifyOTpUseLogic from "./VerifyOtp/useVerifyOTpUseLogic";
import QuickSignUp from "./QuickSignUp";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

import dataCountry from "./data/countryData";
// import md5 from 'crypto-js/md5';

import { arrowDownIcon, underScoreIcon, editIcon } from "../../assets/icons";

import "./sign-in.css";
import BackDrop from "../ui/backdrop/BackDrop";
import { getAnalytics, setUserProperties } from "firebase/analytics";

import { FirebaseContext } from "../../context/FirebaseContext";
// import LogoutDevicesPopup from "./VerifyOtp/logoutDevicesPopup";
// import DeviceIDAPI from "../DevicesIDS/DeviceIDAPI";
import NameData from "./VerifyOtp/NameData";
import useSigninPop from "../../redux/control/useSignInPop";
import { pathsToCheck } from "../navbar/Navbar";
// import { useLocation } from "react-router-dom";
// import { dbImg } from "../../assets/images";

export function loggedInUserCheck(userID) {
  let userIDTest = userID?.toString();
  let result = (userIDTest?.match(/_/g) || [])?.length;
  if (result == 8) {
    return false;
  } else if (userIDTest && userIDTest != '"undefined"') {
    return true;
  } else {
    return false;
  }
}

export default function SignIn({
  subjectualData,
  setUser,
  utmCompaignD = null,
}) {
  const { auth } = useContext(FirebaseContext);
  const { currentSigninPopup, setloginPopVisible } = useSigninPop();

  const location = useLocation();
  const navigate = useNavigate();

  let { defaultLogin, defaultSignin } = location.state || false;

  const {
    onHandleChangeInputOtp,
    userExistsAlready,
    info,
    onVerifyOtp,
    isLoadingOTP,
    setPhoneNumber,
    setAutoSubmit,
    autoSubmit,
    setSelectedCountry,
    selectedCountry,
    setRefrelByUserId,
    setOpenNameModal,
    openNameModal,
    userInfor,
    handleNameUpdate,
    otpCorrection,
    setSubjectAll,
    setUtmCompaignD,
    setSubjectualData,
  } = useVerifyOTpUseLogic();
  // console.log(info)

  // const [userName, setUserName] = useState("");
  // const [userId, setUserId] = useState("");
  // const [profilePicture, setProfilePicture] = useState("");

  const [otpVerify, setOtpVerify] = useState("");
  const [otpTimer, setOtpTimer] = useState({ min: 1, sec: 30 });
  const [isClicked, setIsClicked] = useState(false);
  const [mobileLoginClicked, setMobileLoginClicked] = useState(false);

  const [restforLogin, setRestForLogin] = useState(() =>
    defaultLogin ? "Login" : "Login"
  );
  useEffect(() => {
    setUtmCompaignD(utmCompaignD);
  }, [utmCompaignD]);
  useEffect(() => {
    setSubjectualData(subjectualData);
  }, [subjectualData]);

  // console.log(defaultLogin, location.state, restforLogin)
  const [inputFadeAnime, setInputFadeAnime] = useState(() =>
    defaultLogin ? true : false
  );

  function handleSkipbutton() {
    axios.get("https://api.ipify.org?format=json").then((res) => {
      let ipScore = res.data?.ip?.toString()?.replaceAll(".", "_");
      const uniqueId = uuidv4();

      let user_id = ipScore + "_" + uniqueId?.replaceAll("-", "_");
      console.log(user_id);
      if (!localStorage.getItem("UserID")?.length > 0) {
        axios
          .get(
            "https://o33ra6381d.execute-api.ap-northeast-1.amazonaws.com/addNewUserIDToUserProfile/addnewuseridtouserprofile?UserID=" +
              user_id +
              "&utmCompaignD=" +
              utmCompaignD +
              "&Platform=" +
              window.location.href
          )
          .then((res) => {
            localStorage.setItem("UserID", user_id);
            setUser(user_id);
            setloginPopVisible(false);
            if (
              location.pathname.includes("website") ||
              location.pathname.includes("contact-us")
            ) {
              if (subjectualData?.navbar?.includes("chapters")) {
                navigate(
                  "/chapter-selection" +
                    "?&" +
                    subjectualData?.DropSubjects[0] +
                    "&Test=yes",
                  { state: { UserID: user_id } }
                );
              } else {
                navigate(`/${subjectualData?.navbar[0]}`, {
                  state: { UserID: user_id },
                });
              }
            } else if (
              pathsToCheck.some((path) =>
                window.location.pathname.includes(path)
              )
            ) {
            } else {
              navigate(-1);
            }
            return;
          })
          .catch((err) => console.log(err));
      }

      // console.log(loggedInUserCheck(user_id));

      // console.log(value);
      // localStorage.removeItem('user_id');
    });
    // console.log("hello")
    setloginPopVisible(false);
    if (
      location.pathname.includes("website") ||
      location.pathname.includes("contact-us")
    ) {
      if (subjectualData?.navbar?.includes("chapters")) {
        navigate(
          "/chapter-selection" +
            "?&" +
            subjectualData?.DropSubjects[0] +
            "&Test=yes",
          { state: { UserID: localStorage.getItem("UserID") } }
        );
      } else {
        navigate(`/${subjectualData?.navbar[0]}`, {
          state: { UserID: localStorage.getItem("UserID") },
        });
      }
    } else if (
      pathsToCheck.some((path) => window.location.pathname.includes(path))
    ) {
    } else {
      navigate(-1);
    }
  }

  const [multiDeviceLogin, setMultiDeviceLogin] = useState(false);
  // console.log(selectedCountry)

  const {
    onGetOtp,
    onHandleChange,
    openOtpToFillIn,
    setOpenOTPTOfillIn,
    isLoading,
    phone,
    referred_by,
    isVeryPhone,
    onHandleChangeName,
    name,
    setUserName,
  } = useLogic();
  console.log(referred_by);
  const userID = (selectedCountry.code + phone).slice(1);

  const handleCountryClick = () => {
    // console.log("Set to true");
    setIsClicked(!isClicked);
  };

  // const handleNumberInput = () => {
  //   onHandleChangeInputOtp()
  // }

  // function handleChnageSignupForOnePortion() {
  //   if (restforLogin === "SignUp") {
  //     setRestForLogin("Login");
  //     setOpenOTPTOfillIn(false);
  //     setOtpVerify(0);
  //   } else {
  //     setRestForLogin("SignUp");
  //     setOpenOTPTOfillIn(false);
  //     setOtpVerify(0);
  //   }
  //   setInputFadeAnime(!inputFadeAnime);
  // }
  // console.log(  userID)
  function HandleSubmitOtpforSubmisssion() {
    // const userAgent = window.navigator.userAgent;
    // const browserVersion = window.navigator.appVersion;
    // const screenWidth = window.screen.width;
    // const screenHeight = window.screen.height;

    // // Generate a unique ID using available information
    // const combinedString = userAgent + browserVersion + screenWidth + screenHeight;

    // // Using MD5 hashing function to create a unique ID
    // const deviceID = md5(combinedString).toString();
    // console.log(deviceID)
    // const URl = `UserID=${userID}&DeviceID=${deviceID}&checkBridge=yes`;
    // DeviceIDAPI(URl).then(res => {
    //     let adata = res.data
    //     // console.log(adata)

    //     if (adata?.Message != 'NotPresent') {

    // console.log(adata)

    if ((!userInfor.length || !userInfor[0]?.NAME?.length) && !name?.length) {
      alert("Please Enter Your Name");
    } else {
      if (!userInfor.length) {
        onVerifyOtp();
      }
      if (!userInfor[0]?.NAME?.length && !name?.length) {
        alert("Enter Your Name");
      } else {
        if (!userInfor[0]?.NAME?.length && name?.length) {
          handleNameUpdate();
          // .then(res => {
          // })
        }
        onVerifyOtp();
      }
    }
    // AccessAllow

    //     } else {
    //         // popup open
    //         setMultiDeviceLogin(true)
    //     }

    // }).catch(err => console.log(err))

    // // if (restforLogin === "SignUp") {

    // //   if (userExistsAlready) {
    // //     setOpenOTPTOfillIn(false);
    // //     setOtpVerify(0);
    // //     setRestForLogin("Login");
    // //     alert("User Already Exists!!!");
    // //   } else {
    // //     onVerifyOtp();
    // //   }
    // // }
    // // if (restforLogin === "Login") {
    // //   if (!userExistsAlready) {
    // //     setOpenOTPTOfillIn(false);
    // //     setOtpVerify(0);
    // //     setRestForLogin("SignUp");
    // //     alert("User Does Not Exist!!!");
    // //   } else {
    //   // }
    //   // }
    //   onVerifyOtp();
  }

  useEffect(() => {
    if (otpCorrection) {
      setUser(userID);
    }
  }, [otpCorrection]);

  useEffect(() => {
    setSubjectAll(subjectualData);
  }, [subjectualData]);
  useEffect(() => {
    // console.log(user)
    let uidTest = auth
      ? auth.currentUser?.uid
      : Math.floor((10000000 + Math.random()) * 0x10000)
          .toString(32)
          .substring(1);
    if (uidTest != '"undefined"' && uidTest) {
      // const uidTests = Math.floor((10000000000000 + Math.random()) * 0x100000)
      //   .toString(32)
      //   .substring(1)
      // uidTest = "New User " + uidTests

      const analytics = getAnalytics();
      setUserProperties(analytics, { user_id: uidTest });
    }
    // console.log(uidTest)
    // const userid = auth.currentUser?.phoneNumber
    //     ? auth.currentUser.phoneNumber?.substring(
    //         1,
    //         auth.currentUser.phoneNumber?.length
    //     )
    //     : '"' + auth.currentUser?.email + '"';
    // console.log(uidTest, auth.currentUser)
    // const analytics = getAnalytics();
    // setUserProperties(analytics, { user_id: uidTest });
  }, [window.location.pathname, auth]);

  useEffect(() => {
    info.otp = otpVerify;

    if (referred_by || referred_by?.length > 7) {
      setRefrelByUserId(referred_by);
    }

    if (autoSubmit) {
      if (info.otp?.length === 6) {
        HandleSubmitOtpforSubmisssion();
        setAutoSubmit(false);
      }
    } else {
      setOtpVerify(0);
      setAutoSubmit(true);
    }
  }, [
    otpVerify,
    restforLogin,
    setRestForLogin,
    referred_by,
    setRefrelByUserId,
    onVerifyOtp,
    setOpenOTPTOfillIn,
    userExistsAlready,
    info,
    autoSubmit,
  ]);

  function handleOtpClickGet() {
    onGetOtp();
    // console.log(restforLogin)
    // if (info.name === "" && restforLogin === "SignUp") {
    //   alert("Name is required.");
    //   return;
    // }

    // if (!isVeryPhone) {
    //   alert("Phone number not valid.");
    //   return;
    // }

    // const userAgent = window.navigator.userAgent;
    // const browserVersion = window.navigator.appVersion;
    // const screenWidth = window.screen.width;
    // const screenHeight = window.screen.height;

    // // Generate a unique ID using available information
    // const combinedString = userAgent + browserVersion + screenWidth + screenHeight;

    // // Using MD5 hashing function to create a unique ID
    // const deviceID = md5(combinedString).toString();
    // // console.log(deviceID)
    // const URl = `UserID=${userID}&DeviceID=${deviceID}&checkBridge=yes`;
    // DeviceIDAPI(URl).then(res => {
    //   let adata = res.data
    //   // console.log(deviceID, adata)
    //   // console.log(!(adata?.length) || adata?.length && !adata[0].DeviceIDs.includes(","))

    //   if ((adata?.Message != 'NotPresent')) {

    //     // console.log(adata)

    //     // adding for 1st-2 user deviceID
    //     let commaIncluder = (adata?.length && !adata[0].DeviceIDs.includes(","))
    //     if ((!(adata?.length) || commaIncluder) || (adata?.length && adata[0].DeviceIDs.includes(deviceID))) {

    //       if ((adata?.length && adata[0].DeviceIDs.includes(deviceID))) {
    //         onGetOtp();
    //       } else if ((!(adata?.length) || commaIncluder)) {

    //         handleOTPPOPUPdevicemulti();
    //         onGetOtp();
    //       }
    //       else {
    //         // popup open
    //         setMultiDeviceLogin(true)
    //       }

    //     }

    //     // AccessAllow

    //   } else {
    //     // popup open
    //     setMultiDeviceLogin(true)
    //   }

    // }).catch(err => console.log(err))

    // // if (restforLogin === "SignUp") {

    // //   if (userExistsAlready) {
    // //     setOpenOTPTOfillIn(false);
    // //     setOtpVerify(0);
    // //     alert("User Already Exists!!!");
    // //     handleChnageSignupForOnePortion();
    // //   } else {
    // //     onGetOtp();
    // //   }
    // // }

    // // if (restforLogin === "Login") {
    // // console.log(userExistsAlready)
    // // if (!userExistsAlready) {
    // // axios
    // //   .get("https://uhuu9h6pef.execute-api.ap-northeast-1.amazonaws.com/getUserProfileDetails/getuserprofiledetails?UserID=" +
    // //     "91" + phone,
    // //     {
    // //       headers: {
    // //         "Content-Type": "application/x-www-form-urlencoded",
    // //       },
    // //     }
    // //   ).then((resp) => {
    // // const data = resp.data;
    // // console.log(data[0] ? true : false)
    // // if (!data[0]) {
    // //   setOpenOTPTOfillIn(false);
    // //   setOtpVerify(0);
    // //   alert("User Does Not Exist!!!");
    // //   handleChnageSignupForOnePortion();
    // // }
    // // else {
    // onGetOtp();

    // // }

    // // }).catch((err) => console.log(err));

    // //   } else {
    // //     // onGetOtp();
    // //   }
    // // }
  }

  const [isNumberSet, setisNumberSet] = useState(false);

  const handleEditBtn = () => {
    // console.log('edit number')
    setisNumberSet(false);
    setOpenOTPTOfillIn(false);
  };

  const handleOnKeyDown = (e) => {
    if (
      (selectedCountry.code.slice(1, selectedCountry.code.length) + +phone)
        .length === 12 &&
      e.key === "Enter"
    )
      handleOtpClickGet();
  };

  const handleNavigation = (destination) => {
    setloginPopVisible(false);
    navigate(`/${destination}`);
  };

  useEffect(() => {
    setPhoneNumber(+phone);

    if (referred_by) setRestForLogin("SignUp");

    if (openOtpToFillIn) {
      if ("OTPCredential" in window) {
        window.addEventListener("DOMContentLoaded", () => {
          const input = document.querySelector(
            'input[autocomplete="one-time-code"]'
          );
          // if (!input) return;
          const ac = new AbortController();
          const form = input.closest("form");
          if (form) {
            form.addEventListener("submit", () => {
              ac.abort();
            });
          }
          navigator.credentials
            .get({
              otp: { transport: ["sms"] },
              signal: ac.signal,
            })
            .then((otp) => {
              input.value = otp.code;
              if (form) form.submit();
              setOtpVerify(otp.code);
            })
            .catch((err) => {
              console.log(err);
            });
        });
      }
    }
  }, [
    otpVerify,
    openOtpToFillIn,
    setPhoneNumber,
    isVeryPhone,
    phone,
    referred_by,
  ]);

  useEffect(() => {
    openOtpToFillIn && !isLoadingOTP && setisNumberSet(true);
  }, [openOtpToFillIn]);

  // const handleOTPPOPUPdevicemulti = () => {

  //   const userAgent = window.navigator.userAgent;
  //   const browserVersion = window.navigator.appVersion;
  //   const screenWidth = window.screen.width;
  //   const screenHeight = window.screen.height;

  //   // Generate a unique ID using available information
  //   const combinedString = userAgent + browserVersion + screenWidth + screenHeight;

  //   // Using MD5 hashing function to create a unique ID
  //   const deviceID = md5(combinedString).toString();
  //   // console.log(deviceID)
  //   const URl = `UserID=${userID}&DeviceID=${deviceID}`;
  //   DeviceIDAPI(URl).then(res => {
  //     let adata = res.data
  //     // console.log(adata)

  //     setMultiDeviceLogin(false)
  //     onGetOtp()

  //   }).catch(err => console.log(err))

  // }

  const handleNameChange = (objects) => {
    if (name.length) {
      console.log(name);
    } else {
      alert("Please Enter a Name");
    }
  };
  // console.log(otpVerify)

  // useEffect(() => {
  //   // Use setTimeout to delay the logic execution for 1000 milliseconds (1 second)
  //   // let timer = setTimeout(() => {
  //   // console.log(1,authUser?.currentUser ,  uid,authUser)
  //   // if (authUser?.currentUser) {
  //   //     console.log(2)
  //   let state = {};
  //   //     if (+uid.slice(1, uid.length) === 12) {
  //   //         setUserCheck({ UserID: uid.slice(1, uid.length) });
  //   //         state = { UserID: uid.slice(1, uid.length) };
  //   //     } else {
  //   //         setUserCheck({ UserID: uid });
  //   // console.log(auth)
  //   state = { UserID: auth?.currentUser?.phoneNumber ? auth.currentUser.phoneNumber : auth?.currentUser?.email };
  //   //     }

  //   // setLoading(false)
  //   // }
  //   // console.log(state)
  //   // if (state.UserID) {

  //   //   // console.log(state.UserID)
  //   //   // const userExists = await checkUserExistReturn('"' + res.user.email + '"', setCurrentUser, createLocalUserData);

  //   //   // navigate("/dashboard", state);
  //   // }
  //   // }, 1500);

  //   // return () => (timer); // Clear the timeout if the component unmounts
  // }, [auth, auth?.currentUser?.phoneNumber ? auth.currentUser.phoneNumber : auth?.currentUser?.email]);
  // console.log(otpTimer)
  useEffect(() => {
    // if (otpTimer.min <= 0 && otpTimer.sec <= 0) {
    //   return
    // }

    if ((isLoading || openOtpToFillIn) && (otpTimer.min || otpTimer.sec)) {
      const interval = setInterval(() => {
        setOtpTimer((prevTime) => {
          const sec = prevTime.sec - 1;
          const min = sec === -1 ? prevTime.min - 1 : prevTime.min;
          // console.log(prevTime);
          if (prevTime.sec === 0 && prevTime.min === 0)
            return {
              min: 0,
              sec: 0,
            };
          return {
            min: (min + 60) % 60,
            sec: (sec + 60) % 60,
          };
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isLoading, openOtpToFillIn]);
  useEffect(() => {
    if (name.length)
      onHandleChangeInputOtp({ target: { value: name } }, "name");
  }, [name]);

  // useEffect(() => {
  //   const options = {
  //     headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //     },
  // };
  //   axios.get('https://ipinfo.io/json',options).then(res=>{
  //     console.log(res.data)
  //   }).catch(err=>console.log(err))

  // }, [])
  // console.log( Intl.DateTimeFormat().resolvedOptions().timeZone  )
  // fetch('https://ipinfo.io/json')
  // .then(response => response.json())
  // .then(data => {
  //   console.log(data.country); // This will give you the country
  // });
  // console.log(navigator.geolocation.getCurrentPosition((position) => {
  //   const { latitude, longitude } = position.coords;
  //   console.log(position)
  //   // Use reverse geocoding to get country details from latitude and longitude
  // }))

  return (
    <>
      <Helmet>
        <title> Nio | Auth </title>
        <meta
          name="Description"
          content="Sign in to your account and access your personalized dashboard. Enter your username and password to securely log in and manage your account information"
        />
      </Helmet>

      <div className="sign-up-container">
        <div className="sign-up">
          {/* <div className="sign-up__header">
            <h1 className="sign-up__title">
              {restforLogin === "Login" ? "Login" : "Sign Up"}
            </h1>

            <p className="sign-up__desc">
              Welcome to NioPractice! We're excited that you're considering joining our community of learners.
            </p>
          </div> */}
          <div className="about-img-main app-img-border-rotate large rotatingBackground">
            <div className={`sign-up__form`}>
              {!(
                location?.pathname?.toLowerCase()?.includes("quicktest") ||
                location?.pathname?.toLowerCase()?.includes("freetest")
              ) ? (
                <div
                  className="sign-up_Close-btn"
                  onClick={() => handleSkipbutton()}
                  id="CloseBtnSignInCrossIcon"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M27.0712 25.3C27.56 25.7875 27.56 26.5875 27.0712 27.075C26.5837 27.5625 25.7913 27.5625 25.3025 27.075L20.0075 21.7751L14.675 27.1124C14.1825 27.5999 13.385 27.5999 12.8925 27.1124C12.4013 26.6124 12.4013 25.8125 12.8925 25.325L18.225 19.9875L12.93 14.7C12.4412 14.2125 12.4412 13.4125 12.93 12.925C13.4162 12.4375 14.2087 12.4375 14.6975 12.925L19.9925 18.2249L25.365 12.85C25.8575 12.3625 26.6537 12.3625 27.1462 12.85C27.6375 13.35 27.6375 14.1375 27.1462 14.6375L21.775 20.0125L27.0712 25.3ZM20 0C8.95375 0 0 8.95 0 20C0 31.05 8.95375 40 20 40C31.0462 40 40 31.05 40 20C40 8.95 31.0462 0 20 0Z"
                      fill="#2F99D7"
                    />
                  </svg>
                </div>
              ) : null}
              <div className="sign-up__header">
                <h1 className="sign-up__title">
                  {/* {restforLogin === "Login" ? "Login" : "Sign Up"} */}
                  Get started
                </h1>

                <p className="sign-up__desc">
                  <span className="nonshaddyBackgroundText">
                    Log in to access Insightful Dashboards, Personalized AI
                    notes, Revision tools and Save your progress.
                  </span>
                  <br />
                  {/* <div> */}
                  <span
                    className="shaddyBackgroundText"
                    style={{
                      top: "0.5em",
                    }}
                  >
                    {/* &nbsp;&nbsp;&nbsp;&nbsp;  */}
                    Join 40000+ Students!
                  </span>
                  <span className="shaddyBackground">
                    <svg
                      width="342"
                      height="42"
                      viewBox="0 0 342 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M336.748 20.437C337.617 20.4739 338.537 20.4739 339.763 20.5107C338.894 20.7684 338.179 20.9525 337.515 21.1367C336.34 21.3576 334.704 21.3944 334.296 21.91C335.267 21.9836 335.829 22.1309 334.602 22.315C332.456 22.6464 330.362 23.0147 327.909 23.0515C327.943 23.1497 327.977 23.2479 328.011 23.3461C331.23 23.9721 331.23 24.0825 328.42 24.6349C328.113 24.7822 327.654 24.819 327.143 24.819C326.529 24.9663 325.916 25.1136 325.303 25.2609C324.384 25.5555 323.975 25.8869 324.639 26.292C324.196 26.4883 323.753 26.6848 323.311 26.8811C323.345 26.9548 323.362 27.0284 323.362 27.1021C323.975 26.9916 324.537 26.8443 325.405 26.6602C325.303 27.5071 322.238 27.7649 322.646 28.5382C322.749 28.8696 322.238 29.0537 321.522 29.201C320.398 29.6061 319.479 30.0848 317.69 30.2321C317.213 30.4285 316.754 30.6249 316.311 30.8213C316.549 30.8949 316.788 30.9685 317.026 31.0422C317.946 31.079 318.661 30.7108 319.887 30.9685C318.048 31.1895 316.975 31.7418 315.136 31.8523C313.041 32.5888 310.179 32.6624 307.471 32.8834C306.62 32.957 305.768 33.0184 304.917 33.0675C304.304 33.092 303.691 33.1043 303.077 33.1043C302.805 33.1043 302.532 33.1043 302.26 33.1043C302.209 33.1411 302.158 33.1411 302.107 33.1411C302.26 33.2148 302.464 33.2516 302.515 33.2884C302.345 33.853 302.175 34.4054 302.004 34.9455C302.379 35.0191 302.754 35.0928 303.129 35.1664C304.253 35.2033 305.275 35.3505 306.347 35.7188C304.917 35.7188 303.946 35.6451 303.077 35.4242C302.09 35.4242 301.119 35.4242 300.165 35.4242C300.063 35.4242 300.012 35.4242 299.961 35.4242C299.399 35.9766 297.866 35.6451 296.793 35.7924C296.589 35.9397 296.18 36.0134 295.669 36.0134C295.464 36.1975 295.107 36.3448 294.494 36.4184C293.216 36.8603 291.99 37.3022 289.895 37.2285C290.508 37.5722 291.121 37.9159 291.735 38.2596C291.871 38.3087 291.956 38.3578 291.99 38.4069C292.859 38.9592 292.859 39.4748 291.53 39.9535C290.202 40.4322 290.355 41.095 289.231 41.6105C288.976 42.1261 288.107 42.0524 287.136 41.8315C285.297 41.721 283.304 41.9419 281.567 41.6105C278.604 41.5369 275.589 41.6842 272.677 41.3896C272.064 41.365 271.467 41.3528 270.888 41.3528C269.304 41.3896 267.721 41.4264 266.239 41.2055C264.604 41.1809 262.969 41.1564 261.334 41.1318C259.188 41.1687 257.042 41.1687 254.947 40.9845C254.913 40.9845 254.879 40.9845 254.845 40.9845C253.006 40.96 251.166 40.9477 249.327 40.9477C248.884 40.9477 248.441 40.9477 247.998 40.9477C246.738 40.9232 245.461 40.9109 244.166 40.9109C243.144 40.9109 242.106 40.9109 241.05 40.9109C238.733 40.9109 236.4 40.9232 234.05 40.9477C232.176 40.9477 230.303 40.9477 228.429 40.9477C227.987 40.9477 227.527 40.9477 227.05 40.9477C223.507 40.9968 219.965 41.0582 216.422 41.1318C210.7 41.1318 204.977 41.1318 199.255 41.1318C198.812 41.1318 198.369 41.1318 197.926 41.1318C191.659 41.1564 185.391 41.1809 179.124 41.2055C176.16 41.5737 173.095 41.2791 170.08 41.3528C169.62 41.6105 168.854 41.5737 168.088 41.5737C166.827 41.5737 165.567 41.586 164.307 41.6105C163.591 41.9051 162.672 41.7578 161.65 41.6842C162.331 41.586 162.995 41.4878 163.642 41.3896C163.234 41.3896 162.825 41.4264 162.416 41.3896C160.372 41.3896 158.346 41.3896 156.336 41.3896C149.643 41.721 142.898 41.5737 136.154 41.6105C134.928 41.7333 133.685 41.7333 132.424 41.6105C132.254 41.6351 132.101 41.6474 131.964 41.6474C131.913 41.6474 131.811 41.6105 131.76 41.6105C128.95 41.9051 126.037 41.721 123.176 41.7578C122.563 41.7578 121.933 41.7578 121.286 41.7578C119.174 41.7824 117.062 41.8069 114.95 41.8315C115.154 41.8806 115.137 41.9297 114.899 41.9788C109.619 41.9788 104.34 41.9788 99.0599 41.9788C98.0381 42.0156 97.0673 41.9788 96.1476 41.7947C95.8751 41.7947 95.6026 41.7947 95.3301 41.7947C94.0016 41.8315 92.6732 41.7947 91.3959 41.7947C91.1574 41.7947 90.919 41.7947 90.6805 41.7947C86.4908 41.7947 82.2501 41.721 78.0093 41.6842C76.5787 41.6842 75.1991 41.7578 73.7685 41.7947C73.5641 41.7947 73.3597 41.7947 73.1554 41.7947C71.6566 41.7947 70.1579 41.7824 68.6591 41.7578C67.4329 41.8315 66.1555 41.8683 64.9293 41.7578C62.1702 41.5369 59.2579 41.721 56.5499 41.3896C56.1752 41.3896 55.7835 41.3896 55.3747 41.3896C54.0463 41.4632 52.7179 41.4632 51.5938 41.1687C51.3894 41.1932 51.185 41.2055 50.9807 41.2055C50.3165 41.5369 49.3457 41.3896 48.426 41.3896C46.8421 41.6105 45.5136 41.2423 44.0319 41.1687C40.813 41.5001 38.0028 40.9109 34.9372 40.8004C34.1538 40.7759 33.3703 40.7513 32.5869 40.7268C29.1636 40.6899 25.7403 40.5058 22.9813 39.7325C24.1564 38.9961 21.7039 39.217 21.0908 38.9224C20.8864 38.947 20.6991 38.947 20.5288 38.9224C19.2685 38.8242 18.0081 38.7383 16.7478 38.6647C14.8403 38.6647 12.9328 38.6647 11.0253 38.6647C9.28813 38.6278 7.49985 38.8856 5.86485 38.5174C5.69454 38.4928 5.54125 38.4805 5.405 38.4805C5.60938 38.0755 6.98891 38.1123 7.60203 37.8545C7.87454 37.9282 8.14704 38.0018 8.41954 38.0755C8.47063 37.8545 8.26625 37.7441 7.60203 37.8545C7.46578 37.7072 7.34657 37.5722 7.24438 37.4495C6.01813 37.4863 4.79188 37.4863 3.15688 37.5231C4.53641 37.0812 5.96704 37.3022 7.14219 37.1917C7.85751 36.934 8.52173 36.6394 9.69688 36.6025C10.31 36.4184 8.77719 36.087 10.2589 35.9765C10.8039 35.9029 11.3489 35.8415 11.8939 35.7924C11.7917 35.7188 11.5874 35.6819 11.5874 35.5715C10.9742 35.4487 10.3441 35.3137 9.69688 35.1664C8.84532 35.1664 8.01078 35.1664 7.19328 35.1664C7.29547 35.3137 7.4147 35.461 7.55095 35.6083C6.58016 35.6451 6.32469 35.3874 5.91594 35.1664C5.09844 35.0191 4.38313 34.835 4.07657 34.5036C5.35391 34.5036 5.60938 34.9087 6.52907 34.9823C7.0911 34.5036 4.84297 34.3931 5.25172 33.9513C4.43422 33.804 3.77 33.583 3.36125 33.3253C2.74812 33.2148 2.18609 33.0675 1.87953 32.8465C2.64594 32.6256 3.31016 32.9938 4.02547 32.8834C4.02547 32.8343 4.02547 32.7729 4.02547 32.6992C4.22984 32.552 4.43422 32.4169 4.63859 32.2942C4.63859 32.0733 4.63859 31.8646 4.63859 31.6682C3.58265 31.5945 2.52672 31.5209 1.47078 31.4472C1.06203 31.4104 0.244529 31.4104 0.602186 31.1895C1.01094 30.9317 1.98172 31.079 2.74812 31.0422C4.02547 30.6371 4.68969 30.1584 4.63859 29.5693C5.49016 29.3729 6.34172 29.1765 7.19328 28.9801C8.01078 28.575 8.98157 28.2068 9.5436 27.7649C10.2078 27.323 11.1786 27.4703 12.1494 27.5071C11.9791 27.2862 11.8258 27.0775 11.6895 26.8811C11.9961 26.292 13.4267 26.3288 14.7552 26.2551V26.1815V26.071C14.653 25.666 15.5727 25.445 16.4413 25.2241C17.2077 24.9663 18.1274 24.8558 19.1492 24.819C19.558 24.6717 19.9838 24.5367 20.4266 24.414C19.6091 24.2176 18.7745 24.0089 17.923 23.788C17.6164 23.6775 17.2077 23.567 17.0544 23.4197C16.85 23.2356 16.3902 23.0147 16.1347 22.8306C15.0106 22.9042 13.8866 22.941 12.7114 22.7937C10.7698 22.941 9.64579 22.4623 8.31735 22.1677C5.86485 22.0941 3.31016 22.6464 0.5 21.91C2.1861 21.91 3.41234 21.91 4.63859 21.91C5.55828 21.91 5.71157 21.7995 5.25172 21.5417C4.38313 21.5417 3.46344 21.5049 2.23719 21.5049C3.10578 21.2471 3.8211 21.063 4.48532 20.8789C5.66047 20.658 7.29547 20.6212 7.70422 20.0688C6.73344 20.032 6.17141 19.8847 7.39766 19.7006C9.5436 19.3692 11.6384 19.0009 14.0909 18.9641C14.0569 18.8659 14.0228 18.7677 13.9888 18.6695C10.7698 18.0067 10.7698 17.933 13.58 17.3807C13.8866 17.2334 14.3464 17.1966 14.8574 17.1966C15.4705 17.0493 16.0836 16.8897 16.6967 16.7178C17.6164 16.4601 18.0252 16.1287 17.361 15.7236C17.8038 15.5272 18.2466 15.3186 18.6894 15.0976C18.6553 15.0485 18.6383 14.9872 18.6383 14.9135C18.0252 15.024 17.4631 15.1713 16.5434 15.3554C16.6967 14.5085 19.7624 14.2507 19.3536 13.4406C19.2514 13.146 19.7624 12.9619 20.4777 12.8146C21.6017 12.4095 22.5214 11.894 24.3097 11.7835C24.7866 11.5871 25.2464 11.3907 25.6892 11.1943C25.4508 11.1207 25.2124 11.047 24.9739 10.9734C24.0542 10.9366 23.3389 11.268 22.1127 11.047C23.9521 10.8261 25.025 10.2738 26.8644 10.1265C28.9592 9.42681 31.8205 9.35316 34.5285 9.13222C35.38 9.05857 36.2316 8.98493 37.0832 8.91129C37.6963 8.91129 38.3094 8.91129 38.9225 8.91129C39.195 8.91129 39.4675 8.899 39.74 8.87445C39.7911 8.87445 39.8422 8.87445 39.8933 8.87445C39.74 8.8008 39.5357 8.76398 39.4846 8.69033C39.6549 8.15026 39.8252 7.61019 39.9955 7.07011C39.6208 6.99647 39.2461 6.91054 38.8714 6.81234C37.7474 6.77552 36.7255 6.66504 35.6525 6.29681C37.0832 6.29681 38.0539 6.37045 38.9225 6.59139C39.9103 6.59139 40.8811 6.59139 41.8349 6.59139C41.9371 6.59139 41.9882 6.59139 42.0393 6.59139C42.6013 6.00221 44.1341 6.37045 45.2071 6.22316C45.4114 6.07586 45.8202 6.00222 46.3311 6.00222C46.5355 5.81811 46.8932 5.67082 47.5063 5.59717C48.7836 5.15529 50.0099 4.67657 52.1047 4.75022C51.4916 4.40653 50.8785 4.06285 50.2654 3.71916C50.1291 3.69461 50.0439 3.65779 50.0099 3.6087C49.1413 3.05634 49.1413 2.50399 50.4697 2.06211C51.7982 1.5834 51.6449 0.883755 52.769 0.405049C53.0244 -0.147303 53.893 -0.0368235 54.8638 0.184117C56.7032 0.294588 58.6958 0.073638 60.433 0.405049C63.3965 0.478696 66.411 0.294592 69.3233 0.626004C69.9365 0.626004 70.5326 0.638269 71.1116 0.662818C72.6955 0.625995 74.2794 0.58918 75.7612 0.810121C77.3962 0.83467 79.0312 0.859201 80.6662 0.88375C82.8632 0.846927 85.0091 0.810112 87.1551 1.03105C88.9944 1.03105 90.8338 1.04332 92.6732 1.06787C93.116 1.06787 93.5588 1.06787 94.0016 1.06787C95.2619 1.06787 96.5393 1.06787 97.8337 1.06787C98.8556 1.06787 99.8945 1.06787 100.95 1.06787C103.267 1.06787 105.6 1.06787 107.95 1.06787C109.824 1.06787 111.697 1.06787 113.571 1.06787C114.013 1.06787 114.473 1.06787 114.95 1.06787C118.493 1.01877 122.035 0.957397 125.578 0.88375C131.3 0.88375 137.023 0.88375 142.745 0.88375C143.188 0.88375 143.631 0.88375 144.074 0.88375C150.341 0.859201 156.609 0.83467 162.876 0.810121C162.978 0.810121 163.029 0.810121 163.132 0.810121C166.044 0.47871 169.007 0.736465 171.92 0.662818C172.38 0.405054 173.146 0.441886 173.912 0.441886C175.173 0.417337 176.433 0.405049 177.693 0.405049C178.409 0.110461 179.328 0.257751 180.35 0.331398C179.669 0.429594 179.005 0.51552 178.357 0.589167C178.766 0.62599 179.175 0.552357 179.584 0.626004C181.628 0.626004 183.654 0.613716 185.664 0.589167C192.357 0.294579 199.102 0.441873 205.846 0.405049C207.072 0.282304 208.316 0.282304 209.576 0.405049C209.746 0.3805 209.899 0.368235 210.036 0.368235C210.087 0.368235 210.189 0.368226 210.24 0.405049C213.05 0.110461 215.963 0.294592 218.824 0.257769C219.437 0.257769 220.067 0.257769 220.714 0.257769C222.826 0.208671 224.938 0.184117 227.05 0.184117C226.811 0.135019 226.828 0.0859125 227.101 0.0368145C232.381 0.0122655 237.66 0 242.94 0C243.962 0 244.933 -8.99085e-06 245.852 0.220932C246.125 0.220932 246.397 0.220932 246.67 0.220932C247.998 0.184108 249.327 0.220932 250.604 0.220932C250.843 0.220932 251.064 0.220932 251.268 0.220932C255.509 0.220932 259.75 0.294583 263.991 0.294583C265.421 0.331407 266.801 0.257755 268.231 0.220932C268.436 0.220932 268.64 0.220932 268.845 0.220932C270.343 0.220932 271.842 0.220932 273.341 0.220932C274.567 0.184108 275.844 0.110475 277.071 0.257769C279.83 0.47871 282.742 0.257769 285.45 0.626004C285.825 0.626004 286.217 0.626004 286.625 0.626004C287.954 0.552357 289.282 0.552348 290.406 0.846936C290.611 0.822387 290.815 0.810121 291.019 0.810121C291.684 0.47871 292.654 0.58918 293.574 0.626004C295.158 0.368239 296.486 0.773289 297.968 0.846936C301.187 0.478701 303.997 1.1047 307.063 1.21517C307.846 1.23972 308.63 1.25198 309.413 1.25198C312.836 1.32563 316.26 1.47294 319.019 2.28306C317.844 3.01953 320.296 2.79858 320.909 3.05634C321.114 3.0318 321.284 3.04406 321.42 3.09316C322.715 3.19136 323.992 3.27728 325.252 3.35093C327.16 3.35093 329.067 3.35093 330.975 3.35093C332.712 3.38775 334.5 3.13 336.135 3.49823C336.305 3.52278 336.459 3.53505 336.595 3.53505C336.391 3.9401 335.011 3.90329 334.398 4.16105C334.534 4.30834 334.653 4.44335 334.756 4.5661C335.982 4.52928 337.208 4.52929 338.843 4.49247C337.464 4.93435 336.033 4.7134 334.858 4.82387C334.142 5.08163 333.478 5.37623 332.303 5.41306C331.69 5.56035 333.223 5.92857 331.741 6.03904C331.196 6.11268 330.651 6.17406 330.106 6.22316C330.157 6.2968 330.413 6.33363 330.413 6.40727C331.026 6.55457 331.656 6.70187 332.303 6.84916C333.155 6.84916 333.989 6.84916 334.807 6.84916C334.67 6.67732 334.551 6.51775 334.449 6.37046C335.42 6.37046 335.675 6.62822 336.084 6.84916C336.902 6.95963 337.617 7.14374 337.923 7.51198C336.646 7.51198 336.391 7.10692 335.471 7.03328C334.909 7.51198 337.106 7.62245 336.748 8.06433C337.566 8.21162 338.23 8.39575 338.639 8.69033C339.252 8.8008 339.814 8.91127 340.12 9.16903C339.354 9.38997 338.69 9.02176 337.975 9.09541C337.975 9.16905 337.975 9.24269 337.975 9.31634C337.77 9.46363 337.566 9.59864 337.361 9.72139C337.361 9.94233 337.361 10.151 337.361 10.3474C338.417 10.421 339.473 10.4947 340.529 10.5683C340.938 10.6052 341.755 10.6052 341.398 10.8261C340.989 11.0839 340.018 10.9366 339.252 10.9734C337.975 11.3785 337.31 11.8203 337.361 12.4095C336.51 12.6305 335.658 12.8391 334.807 13.0355C333.989 13.4406 333.018 13.8088 332.456 14.2139C331.792 14.6926 330.821 14.5453 329.851 14.5084C330.021 14.7048 330.174 14.9135 330.31 15.1344C330.004 15.6868 328.573 15.6868 327.245 15.7604V15.8341V15.9446C327.347 16.3496 326.427 16.5706 325.559 16.7547C324.792 17.0124 323.873 17.1597 322.851 17.1966C322.442 17.3193 322.016 17.4543 321.573 17.6016C322.391 17.798 323.225 17.9944 324.077 18.1908C324.384 18.3381 324.792 18.4486 324.946 18.5959C325.15 18.78 325.61 18.9641 325.865 19.185C326.989 19.1114 328.113 19.0746 329.289 19.2219C331.23 19.0746 332.354 19.5164 333.683 19.8478C336.135 19.9215 338.69 19.3691 341.5 20.1056C339.814 20.1056 338.588 20.1056 337.361 20.0688C336.442 20.0688 336.288 20.2161 336.748 20.437ZM246.67 0.331398C246.67 0.355947 246.67 0.3805 246.67 0.405049C246.738 0.405049 246.789 0.405049 246.823 0.405049C246.789 0.3805 246.738 0.355947 246.67 0.331398ZM227.101 0.220932C232.074 0.220932 237.064 0.220932 242.071 0.220932C237.064 0.184108 232.057 0.147294 227.05 0.184117C227.084 0.184117 227.101 0.196383 227.101 0.220932ZM242.071 0.220932C242.378 0.220932 242.685 0.220932 242.991 0.220932C242.991 0.220932 242.974 0.220932 242.94 0.220932C242.633 0.220932 242.344 0.220932 242.071 0.220932ZM220.714 0.331398C220.714 0.355947 220.714 0.3805 220.714 0.405049C220.782 0.405049 220.833 0.405049 220.868 0.405049C220.816 0.405049 220.765 0.368221 220.714 0.331398ZM220.714 0.589167C220.68 0.613716 220.663 0.626004 220.663 0.626004C220.663 0.626004 220.68 0.626004 220.714 0.626004C220.714 0.626004 220.714 0.613716 220.714 0.589167ZM210.24 0.405049C210.24 0.405049 210.257 0.405049 210.291 0.405049C210.291 0.405049 210.274 0.405049 210.24 0.405049ZM95.3301 41.6474C95.3301 41.6228 95.3301 41.5982 95.3301 41.5737C95.262 41.5737 95.2109 41.5737 95.1768 41.5737C95.2109 41.5982 95.262 41.6228 95.3301 41.6474ZM114.899 41.7947C109.858 41.7947 104.834 41.7947 99.8263 41.7947C104.834 41.8315 109.892 41.8683 114.95 41.8315C114.95 41.8315 114.933 41.8192 114.899 41.7947ZM99.8263 41.7947C99.5538 41.7947 99.2813 41.7947 99.0088 41.7947C99.0088 41.7947 99.0259 41.7947 99.0599 41.7947C99.2984 41.7947 99.5538 41.7947 99.8263 41.7947ZM121.286 41.6842C121.286 41.6596 121.286 41.6228 121.286 41.5737C121.218 41.5737 121.167 41.5737 121.132 41.5737C121.184 41.6105 121.235 41.6474 121.286 41.6842ZM121.286 41.4264C121.32 41.4019 121.337 41.3896 121.337 41.3896C121.337 41.3896 121.32 41.3896 121.286 41.3896C121.286 41.3896 121.286 41.4019 121.286 41.4264ZM168.088 41.3896C168.122 41.4632 168.122 41.5246 168.088 41.5737C168.292 41.5001 168.292 41.4632 168.088 41.3896ZM246.67 0.220932C246.619 0.257755 246.619 0.294574 246.67 0.331398C246.67 0.306849 246.67 0.27003 246.67 0.220932ZM220.714 0.257769C220.68 0.282318 220.68 0.306849 220.714 0.331398C220.714 0.306849 220.714 0.282318 220.714 0.257769ZM220.714 0.405049C220.714 0.478696 220.714 0.540069 220.714 0.589167C220.816 0.552343 220.868 0.478696 220.714 0.405049ZM95.3301 41.7947C95.3812 41.721 95.3812 41.6842 95.3301 41.6474C95.3301 41.6964 95.3301 41.7456 95.3301 41.7947ZM121.286 41.7578C121.32 41.7333 121.32 41.7087 121.286 41.6842C121.286 41.7087 121.286 41.7333 121.286 41.7578ZM121.286 41.5737C121.286 41.5246 121.286 41.4755 121.286 41.4264C121.184 41.4632 121.132 41.5369 121.286 41.5737ZM215.707 40.5426C215.656 40.5426 215.554 40.5426 215.503 40.5426C215.503 40.5672 215.52 40.5795 215.554 40.5795C215.605 40.5795 215.656 40.5795 215.707 40.5426ZM8.47063 38.2596C8.4025 38.2596 8.31735 38.2596 8.21516 38.2596C8.31735 38.2596 8.36844 38.2964 8.47063 38.2596ZM126.293 1.47294C126.344 1.47294 126.446 1.43612 126.497 1.47294C126.497 1.44839 126.48 1.4361 126.446 1.4361C126.395 1.4361 126.344 1.43612 126.293 1.47294ZM288.311 35.2401C288.311 35.2401 288.294 35.2401 288.26 35.2401C288.311 35.2401 288.311 35.2401 288.311 35.2401ZM288.362 35.2032C288.26 35.1296 288.311 35.1664 288.311 35.2401C288.345 35.2401 288.362 35.2278 288.362 35.2032ZM275.282 40.1376C275.248 40.1376 275.231 40.1376 275.231 40.1376C275.231 40.1376 275.231 40.1499 275.231 40.1744C275.231 40.1499 275.248 40.1376 275.282 40.1376ZM53.6376 6.77551C53.7397 6.88598 53.6886 6.81233 53.6886 6.77551C53.6546 6.77551 53.6376 6.77551 53.6376 6.77551ZM66.7176 1.87799C66.7516 1.87799 66.7687 1.87799 66.7687 1.87799C66.7687 1.87799 66.7687 1.86572 66.7687 1.84117C66.7687 1.84117 66.7516 1.85344 66.7176 1.87799ZM214.736 18.78C214.702 18.78 214.685 18.78 214.685 18.78C214.651 18.78 214.634 18.78 214.634 18.78C214.668 18.78 214.702 18.78 214.736 18.78ZM127.264 23.2356C127.298 23.2356 127.315 23.2356 127.315 23.2356C127.349 23.2356 127.366 23.2356 127.366 23.2356C127.332 23.2356 127.298 23.2356 127.264 23.2356ZM97.4249 3.756C97.476 3.756 97.5782 3.756 97.6293 3.756C97.459 3.756 97.2887 3.756 97.1184 3.756C97.2205 3.756 97.3227 3.756 97.4249 3.756ZM100.593 3.53505C100.644 3.53505 100.542 3.53506 100.542 3.57188H100.593C101.002 3.53506 100.439 3.38775 100.593 3.53505ZM85.6734 3.71916C85.7074 3.71916 85.7244 3.71916 85.7244 3.71916C85.7244 3.71916 85.7244 3.71916 85.6734 3.71916ZM74.2794 3.64551C74.3816 3.64551 74.4327 3.64552 74.4838 3.68235C74.586 3.68235 74.586 3.64551 74.586 3.64551C74.4838 3.64551 74.3816 3.64551 74.2794 3.64551ZM69.2722 3.53505C69.2382 3.53505 69.2041 3.53505 69.1701 3.53505C69.1701 3.53505 69.1871 3.53505 69.2211 3.53505C69.2211 3.53505 69.2212 3.53505 69.2722 3.53505ZM23.5433 19.4428C23.5092 19.4428 23.4752 19.4551 23.4411 19.4796C23.5092 19.4551 23.5944 19.4551 23.6966 19.4796V19.4428C23.6625 19.4428 23.6114 19.4428 23.5433 19.4428ZM244.575 38.2596C244.524 38.2596 244.422 38.2596 244.371 38.2596C244.541 38.2596 244.711 38.2596 244.882 38.2596C244.779 38.2596 244.677 38.2596 244.575 38.2596ZM241.407 38.4805C241.356 38.4805 241.458 38.4437 241.458 38.4437H241.407C240.998 38.4805 241.561 38.6278 241.407 38.4805ZM256.327 38.2964C256.327 38.2964 256.276 38.2964 256.327 38.2596C256.276 38.2596 256.276 38.2596 256.276 38.2596C256.276 38.2964 256.276 38.2964 256.327 38.2964ZM267.721 38.3701C267.618 38.3333 267.567 38.3701 267.516 38.3332C267.414 38.3332 267.414 38.3333 267.363 38.3701C267.499 38.3701 267.618 38.3701 267.721 38.3701ZM272.728 38.4805C272.762 38.4805 272.796 38.4805 272.83 38.4805C272.83 38.4805 272.813 38.4683 272.779 38.4437C272.779 38.4805 272.779 38.4805 272.728 38.4805ZM318.457 22.5728C318.491 22.5482 318.525 22.536 318.559 22.536C318.491 22.536 318.406 22.536 318.303 22.536C318.337 22.536 318.389 22.5482 318.457 22.5728ZM322.34 10.3842C322.289 10.3474 322.238 10.3474 322.238 10.3474C322.187 10.3474 322.187 10.3474 322.135 10.3474C322.238 10.3474 322.238 10.3842 322.289 10.3842C322.289 10.3842 322.306 10.3842 322.34 10.3842ZM27.5286 16.902C27.4605 16.9265 27.4094 16.9511 27.3753 16.9756C27.4094 16.9756 27.4605 16.9756 27.5286 16.9756C27.4775 16.9388 27.5286 16.9388 27.5286 16.902ZM19.9156 19.0377C19.9497 19.0377 19.9667 19.0377 19.9667 19.0377H19.9156ZM19.6602 31.6314C19.6942 31.6559 19.7283 31.6682 19.7624 31.6682H19.8135C19.7624 31.6682 19.7624 31.6314 19.7113 31.6314C19.6772 31.6314 19.6602 31.6314 19.6602 31.6314ZM314.471 25.1136C314.539 25.0891 314.591 25.0645 314.625 25.04C314.591 25.04 314.539 25.04 314.471 25.04C314.522 25.0768 314.42 25.0768 314.471 25.1136ZM322.033 22.9778C322.033 22.9778 322.05 22.9778 322.084 22.9778H322.033ZM83.5274 2.68811C83.3912 2.68811 83.2719 2.68811 83.1698 2.68811C83.1698 2.71266 83.1698 2.73721 83.1698 2.76176C83.2719 2.72494 83.3741 2.72493 83.5274 2.68811ZM67.8927 6.62823C67.9268 6.62823 67.9438 6.62823 67.9438 6.62823C67.9438 6.62823 67.9438 6.61594 67.9438 6.59139C67.9438 6.61594 67.9268 6.62823 67.8927 6.62823ZM258.37 39.2907C258.507 39.3152 258.626 39.3152 258.728 39.2907C258.728 39.2661 258.728 39.2416 258.728 39.217C258.626 39.2907 258.524 39.2907 258.37 39.2907ZM314.625 16.276C314.574 16.3128 314.522 16.3128 314.522 16.3496C314.574 16.3496 314.676 16.3496 314.727 16.3496C314.676 16.3496 314.676 16.3128 314.625 16.276ZM284.53 2.02529C284.53 2.02529 284.513 2.02529 284.479 2.02529C284.547 2.02529 284.616 2.02529 284.684 2.02529C284.633 2.02529 284.582 2.02529 284.53 2.02529ZM284.479 2.02529C284.275 1.98847 284.122 2.02528 283.917 2.06211C284.122 2.03756 284.309 2.02529 284.479 2.02529ZM75.0459 1.91483C75.0459 1.91483 74.9947 1.91483 75.0969 1.91483C75.0629 1.91483 75.0459 1.91483 75.0459 1.91483ZM67.8416 2.68811C67.8757 2.68811 67.9097 2.68811 67.9438 2.68811C67.9438 2.66356 67.9438 2.6513 67.9438 2.6513C67.8927 2.6513 67.8927 2.65129 67.8416 2.68811ZM27.2731 25.7028C27.2731 25.7028 27.3753 25.7028 27.3753 25.666C27.3242 25.6292 27.2221 25.666 27.171 25.666C27.2221 25.666 27.2221 25.7028 27.2731 25.7028ZM57.3674 39.9903C57.3333 39.9903 57.2822 39.978 57.2141 39.9535C57.2141 39.9903 57.3163 39.9903 57.3674 39.9903ZM57.3674 39.9903C57.5718 40.0271 57.7761 39.9903 57.9294 39.9535C57.7591 39.978 57.5718 39.9903 57.3674 39.9903ZM70.754 40.6531C70.788 40.6531 70.8051 40.6654 70.8051 40.6899V40.6531C70.8051 40.6531 70.788 40.6531 70.754 40.6531ZM266.801 40.1008C266.801 40.1008 266.801 40.1008 266.75 40.1008C266.75 40.1008 266.767 40.1008 266.801 40.1008ZM274.005 39.3275C273.971 39.3275 273.937 39.3275 273.903 39.3275C273.903 39.3275 273.903 39.3397 273.903 39.3643C273.954 39.3643 273.954 39.3275 274.005 39.3275ZM315.749 18.2276C315.647 18.2276 315.544 18.2276 315.442 18.2276C315.442 18.2276 315.459 18.2276 315.493 18.2276C315.544 18.2276 315.647 18.2276 315.749 18.2276ZM317.69 15.3186C317.639 15.3186 317.639 15.3186 317.588 15.3186C317.622 15.3186 317.656 15.3186 317.69 15.3186ZM241.203 1.25198C241.152 1.21516 241.05 1.25199 240.999 1.21517C240.93 1.23972 240.879 1.25198 240.845 1.25198C240.981 1.25198 241.101 1.25198 241.203 1.25198ZM123.023 1.87799C123.125 1.91481 123.227 1.91483 123.329 1.91483C123.329 1.91483 123.227 1.91481 123.227 1.87799C123.159 1.87799 123.091 1.87799 123.023 1.87799ZM51.2872 8.28528C51.0829 8.28528 50.8614 8.28528 50.623 8.28528C50.8274 8.32211 51.0829 8.28528 51.2872 8.28528ZM26.0469 23.788C26.1491 23.788 26.2513 23.788 26.3535 23.788C26.3194 23.788 26.3024 23.788 26.3024 23.788C26.2002 23.788 26.098 23.788 26.0469 23.788ZM24.0542 26.697C24.1053 26.697 24.1564 26.697 24.1564 26.697C24.1224 26.697 24.0883 26.697 24.0542 26.697ZM100.542 40.7636C100.644 40.7636 100.695 40.7636 100.797 40.8004C100.831 40.7759 100.865 40.7636 100.899 40.7636C100.797 40.7636 100.678 40.7636 100.542 40.7636ZM254.845 40.5426C254.845 40.5426 254.862 40.5426 254.896 40.5426C254.862 40.5426 254.828 40.5426 254.794 40.5426H254.845ZM326.53 14.2875C326.495 14.2875 326.478 14.2875 326.478 14.2875C326.512 14.2875 326.53 14.2875 326.53 14.2875ZM189.292 1.03105C189.326 1.03105 189.343 1.03105 189.343 1.03105H189.394C189.36 1.03105 189.326 1.03105 189.292 1.03105ZM86.8996 1.47294C86.8996 1.47294 86.9166 1.47294 86.9507 1.47294H86.8996ZM80.7683 1.03105C80.7002 1.03105 80.6321 1.03105 80.564 1.03105C80.6151 1.06788 80.6662 1.06787 80.6662 1.06787C80.7002 1.06787 80.7343 1.0556 80.7683 1.03105ZM21.7039 17.3807H21.6528C21.6869 17.3807 21.7039 17.3807 21.7039 17.3807ZM15.2661 27.7281C15.2661 27.7281 15.2661 27.7281 15.3172 27.7281H15.2661ZM218.773 40.1376C218.671 40.1008 218.517 40.1008 218.415 40.0639C218.466 40.1008 218.517 40.1008 218.517 40.1376C218.585 40.1376 218.671 40.1376 218.773 40.1376ZM260.976 40.9477C261.044 40.9477 261.112 40.9477 261.181 40.9477C261.181 40.9477 261.129 40.9477 261.078 40.9477C261.044 40.9477 261.01 40.9477 260.976 40.9477ZM320.041 24.6349L320.092 24.5981C320.092 24.5981 320.075 24.6103 320.041 24.6349ZM333.07 19.8847C333.104 19.9092 333.138 19.9461 333.172 19.9951C333.206 19.9951 333.223 19.9951 333.223 19.9951C333.223 19.9583 333.172 19.9215 333.223 19.8847C333.155 19.8847 333.104 19.8847 333.07 19.8847ZM329.442 3.71916C329.476 3.71916 329.51 3.71916 329.544 3.71916C329.544 3.71916 329.493 3.71916 329.442 3.71916ZM170.54 1.25198C170.54 1.25198 170.591 1.25198 170.642 1.25198C170.591 1.21516 170.642 1.21517 170.642 1.21517C170.608 1.21517 170.574 1.22744 170.54 1.25198ZM164.153 1.03105C164.085 1.03105 164.017 1.01879 163.949 0.994239C163.949 1.03106 164 1.03105 164 1.03105C164.034 1.03105 164.085 1.03105 164.153 1.03105ZM164.205 1.21517C164.17 1.16607 164.153 1.1047 164.153 1.03105C164 1.1047 164.102 1.17835 164.205 1.21517ZM153.424 1.06787C153.356 1.06787 153.305 1.06787 153.27 1.06787C153.305 1.06787 153.322 1.06787 153.322 1.06787C153.356 1.06787 153.39 1.06787 153.424 1.06787ZM121.797 1.25198C121.848 1.28881 121.899 1.252 121.95 1.28882C122.018 1.28882 122.086 1.27653 122.154 1.25198C122.018 1.25198 121.899 1.25198 121.797 1.25198ZM120.468 1.25198C120.4 1.25198 120.349 1.25198 120.315 1.25198C120.315 1.28881 120.213 1.28881 120.213 1.32564C120.264 1.28881 120.417 1.28881 120.468 1.25198ZM67.2285 0.699633C67.2626 0.699633 67.2796 0.699633 67.2796 0.699633C67.3137 0.699633 67.3307 0.699633 67.3307 0.699633C67.3307 0.699633 67.2966 0.699633 67.2285 0.699633ZM67.1774 0.699633C67.1774 0.724182 67.1944 0.724182 67.2285 0.699633C67.1944 0.699633 67.1774 0.699633 67.1774 0.699633ZM8.67501 22.1309C8.64094 22.1064 8.60688 22.0695 8.57282 22.0204C8.53876 22.0204 8.52172 22.0204 8.52172 22.0204C8.52172 22.0573 8.62391 22.0941 8.52172 22.1309C8.58985 22.1309 8.64094 22.1309 8.67501 22.1309ZM12.3027 38.2964C12.2686 38.2964 12.2345 38.2964 12.2005 38.2964C12.2005 38.2964 12.2516 38.2964 12.3027 38.2964ZM171.204 40.7636C171.204 40.7636 171.153 40.7636 171.102 40.7636C171.153 40.8004 171.102 40.8004 171.102 40.8004C171.136 40.8004 171.17 40.7882 171.204 40.7636ZM177.54 40.7636H177.591C177.557 40.7636 177.54 40.7636 177.54 40.7636ZM177.591 40.9845C177.659 40.9845 177.727 40.9968 177.795 41.0213C177.795 40.9845 177.795 40.9845 177.795 40.9845C177.727 40.9845 177.659 40.9845 177.591 40.9845ZM177.591 40.9845C177.744 40.9109 177.642 40.8372 177.591 40.8004C177.591 40.8495 177.591 40.9109 177.591 40.9845ZM188.372 40.9477C188.406 40.9477 188.44 40.9477 188.474 40.9477C188.474 40.9477 188.457 40.9477 188.423 40.9477C188.389 40.9477 188.372 40.9477 188.372 40.9477ZM219.948 40.7636C219.897 40.7268 219.846 40.7636 219.795 40.7268C219.726 40.7268 219.675 40.7391 219.641 40.7636C219.743 40.7636 219.846 40.7636 219.948 40.7636ZM219.948 40.7636C220.391 40.7636 220.833 40.7636 221.276 40.7636C220.868 40.6163 220.408 40.6531 219.948 40.7636ZM221.276 40.7636C221.344 40.7636 221.396 40.7636 221.43 40.7636C221.43 40.7268 221.532 40.7268 221.532 40.6899C221.481 40.7268 221.327 40.7268 221.276 40.7636ZM274.516 41.316C274.482 41.316 274.465 41.316 274.465 41.316C274.431 41.316 274.414 41.316 274.414 41.316C274.448 41.316 274.482 41.316 274.516 41.316ZM274.567 41.316C274.567 41.2914 274.55 41.2914 274.516 41.316C274.55 41.316 274.567 41.316 274.567 41.316Z"
                        fill="#F8219F"
                      />
                    </svg>
                  </span>
                  {/* </div> */}
                </p>
              </div>
              {/* {openOtpToFillIn && */}

              {/* goooooooooogle login */}
              <div style={{ height: "1em" }}></div>
              {/* {!((Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Kolkata") || (Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Calcutta")) ? <> */}

              <div
                className={`GoogleLoginEra ${
                  openOtpToFillIn ? "hide" : "show"
                }`}
                style={{
                  gap: mobileLoginClicked ? "" : "0em",
                }}
              >
                <QuickSignUp
                  utmCompaignD={utmCompaignD}
                  setUser={setUser}
                  userExistsAlready={userExistsAlready}
                  subjectualData={subjectualData}
                  referredBy={referred_by}
                  phoneNumber={
                    selectedCountry.code.slice(1, selectedCountry.code.length) +
                    +phone
                  }
                />
                {/* {mobileLoginClicked ? ( */}
                <div className="line">
                  <img src={underScoreIcon} alt="separatorIcon" />
                  <div className="quick-signup-separation">OR</div>
                </div>
                {/* // ) : null} */}
                {!mobileLoginClicked ? (
                  <div className="sign-up-google sign-up-btn googleLoginStrokeBorder fitterContent">
                    <button onClick={() => setMobileLoginClicked(true)}>
                      {/* <img src={} alt="google" /> */}
                      <div>Continue with Phone</div>
                    </button>
                  </div>
                ) : null}
              </div>
              {/* </> : ""} */}
              {/* google login ends */}
              {/* } */}

              {/* <div className={`sign-up__name-input ${restforLogin === "SignUp" ? "show" : "hide"}`}>

                <div className="sign-up__form__header">

                  <div className="sign-up__label-name">Name </div>
                  <h2 className="sign-up__sub-title">

                    <span style={{ fontSize: "18px" }}>  Already Have an Account? </span>

                    <button className="sign-up__signin-btn"
                      onClick={handleChnageSignupForOnePortion}>
                      Log in
                    </button>
                  </h2>
                </div>

                <div className="sign-up-name">
                  <input
                    type="text"
                    value={info.name}
                    onChange={(e) => onHandleChangeInputOtp(e, "name")}
                    placeholder="Enter your name!"
                    className="sign-up__input"
                  />
                </div>

              </div> */}

              {mobileLoginClicked ? (
                <div
                  className={`sign-up__mobile-input ${
                    restforLogin === "SignUp" ? "show" : "hide"
                  }`}
                >
                  {!openOtpToFillIn ? (
                    <div className="sign-up__form__header">
                      <h2 className={`sign-up__label-mobile-number `}>
                        Continue With Mobile
                      </h2>

                      {/* <h2 className={`sign-up__sub-title ${restforLogin === "SignUp" ? "hidden" : "show"}`}>

                      <span style={{ fontSize: "18px" }}>  New user? </span>
                      <button
                        className="sign-up__login-btn"
                        onClick={handleChnageSignupForOnePortion}
                      >
                        Sign up
                      </button>
                    </h2> */}
                    </div>
                  ) : (
                    <h1 className="sign-up__form-otp-verification-text">
                      {" "}
                      Continue With Mobile
                    </h1>
                  )}

                  {/* number */}

                  <div className={`sign-up-number ${isNumberSet && "set"}`}>
                    <div
                      className={`sign-up__input-country ${
                        isNumberSet && "set"
                      }`}
                    >
                      {!openOtpToFillIn ? (
                        <div
                          className="sign-up__input-country-container"
                          onClick={handleCountryClick}
                        >
                          <img
                            src={selectedCountry.imgURL}
                            className="sign-up__input-country-flag"
                          />
                          <img
                            className={`sign-up__country-dropdown ${
                              isClicked ? "dropdown-active" : ""
                            }`}
                            src={arrowDownIcon}
                            alt="dropdown-arrow"
                          />
                        </div>
                      ) : (
                        <div className="sign-up__input-country-container no-btn">
                          <img
                            src={selectedCountry.imgURL}
                            className="sign-up__input-country-flag"
                          />
                        </div>
                      )}

                      {isClicked && (
                        <>
                          <div className="countries-list">
                            {dataCountry.map((con, idx) => (
                              <div
                                className="country-list-item"
                                key={idx}
                                onClick={() => {
                                  setSelectedCountry(con);
                                }}
                              >
                                <h4> {con.name} </h4>
                                <h4> {con.code} </h4>
                              </div>
                            ))}
                          </div>
                          <BackDrop closeHandler={() => setIsClicked(false)} />
                        </>
                      )}
                    </div>

                    <div
                      className={`sign-up__input-number ${
                        isNumberSet && "set"
                      }`}
                    >
                      {/* {selectedCountry.code} */}
                      <input
                        type="number"
                        value={phone}
                        inputMode="decimal"
                        onKeyDown={handleOnKeyDown}
                        onChange={(e) => onHandleChange(e)}
                        className="sign-up__input-num"
                        placeholder=" "
                        autoFocus
                      />
                      {openOtpToFillIn && (
                        <img
                          src={editIcon}
                          className="sign-up-edit-icon"
                          onClick={handleEditBtn}
                        />
                      )}
                    </div>
                  </div>

                  {/* number --end */}

                  <div className="sign-up__actions-container">
                    {(isLoading || openOtpToFillIn) &&
                      (otpTimer.min === 0 && otpTimer.sec === 0 ? (
                        <p className="sign-up__footnote">
                          There was some Error &nbsp;
                          <button
                            style={{ color: "blue" }}
                            onClick={() => window.location.reload()}
                          >
                            Reload
                          </button>
                        </p>
                      ) : (
                        <div>
                          {otpTimer.min / 10
                            ? otpTimer.min
                            : `0${otpTimer.min}`}
                          :
                          {otpTimer.sec / 10
                            ? otpTimer.sec
                            : `0${otpTimer.sec}`}
                          {isLoading && (
                            <SyncLoader color="#f9f9f9" size={11} />
                          )}
                        </div>
                      ))}{" "}
                    {!openOtpToFillIn && (
                      <>
                        <button
                          disabled={isVeryPhone ? false : true}
                          className={`app-btn-1 short ${
                            (
                              selectedCountry.code.slice(
                                1,
                                selectedCountry.code.length
                              ) + +phone
                            ).length === 12
                              ? "activeBTNOTP"
                              : "getOtpBtnInactive"
                          }`}
                          onClick={handleOtpClickGet}
                        >
                          Get OTP{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                          >
                            <path
                              d="M14.93 5.92969L21 11.9997L14.93 18.0697M4 11.9997H20.83"
                              stroke="#F9F9F9"
                              strokeWidth="1.5"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          {/* <img src={arrowRight} alt="otp" width="18px" /> */}
                        </button>
                      </>
                    )}
                    {/* otp form */}
                    {openOtpToFillIn &&
                      (!isLoadingOTP ? (
                        <OtpForm
                          HandleSubmitOtpforSubmisssion={
                            HandleSubmitOtpforSubmisssion
                          }
                          userInfor={userInfor}
                          name={name}
                          setUserName={setUserName}
                          otpVerify={otpVerify}
                          setOtpVerify={setOtpVerify}
                          setAutoSubmit={setAutoSubmit}
                          autoSubmit={autoSubmit}
                          onHandleChangeName={onHandleChangeName}
                        />
                      ) : (
                        <SyncLoader color="#f9f9f9" />
                      ))}
                  </div>
                </div>
              ) : null}

              <div className="sign-up__footnote">
                By signing up you are agreeing to NioClass
                <button
                  className="sign-up__footnote-btn"
                  onClick={() => handleNavigation("privacy-policy")}
                >
                  {" "}
                  Privacy{" "}
                </button>
                And
                <button
                  className="sign-up__footnote-btn"
                  onClick={() => handleNavigation("terms-and-conditions")}
                >
                  {" "}
                  Terms{" "}
                </button>
              </div>

              {/* capcha div */}

              <div
                id="recaptcha-container"
                className="recaptacha_container_boxify"
                style={{}}
              />
            </div>
          </div>
        </div>
      </div>

      {/* {multiDeviceLogin ? <LogoutDevicesPopup setFormsOpen={setMultiDeviceLogin}
        handleLogoutOtherDevice={handleOTPPOPUPdevicemulti}
      // handleLoginPopUP={console.log("hii")}
      /> : ""} */}
    </>
  );
}
